/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const jaMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'ログイン',
  'user.register': '登録',
  'user.forgot-password': 'パスワードを忘れましたか？',
  'user.email': 'メールアドレス',
  'user.newpassword': '新しいパスワード',
  'user.currentpassword': '現在のパスワード',
  'user.newpasswordagain': '新しいパスワード（確認）',
  'user.password': 'パスワード',
  'user.forgot-password-question': 'パスワードを忘れましたか？',
  'user.fullname': '氏名',
  'user.firstname': '名',
  'user.lastname': '姓',
  'user.login-button': 'ログイン',
  'user.register-button': '登録',
  'user.reset-password-button': 'リセット',
  'user.buy': '購入',
  'user.username': 'ユーザー名',

  /* 03.Menu */
  'menu.app': 'ホーム',
  'menu.default': 'デフォルト',
  'menu.analytics': '分析',
  'menu.ecommerce': 'Eコマース',
  'menu.content': 'コンテンツ',
  'menu.pages': 'ページ',
  'menu.data-list': 'データリスト',
  'menu.thumb-list': 'サムネイルリスト',
  'menu.image-list': '画像リスト',
  'menu.details': '詳細',
  'menu.search': '検索',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.forgot-password': 'パスワードを忘れましたか？',
  'menu.error': 'エラー',
  'menu.applications': 'アプリケーション',
  'menu.todo': 'To-doリスト',
  'menu.survey': 'アンケート',
  'menu.chat': 'チャット',
  'menu.ui': 'UI',
  'menu.edit': '編集',
  'menu.alerts': 'アラート',
  'menu.badges': 'バッジ',
  'menu.buttons': 'ボタン',
  'menu.cards': 'カード',
  'menu.carousel': 'カルーセル',
  'menu.charts': 'チャート',
  'menu.collapse': '折りたたみ',
  'menu.dropdowns': 'ドロップダウン',
  'menu.editors': 'エディター',
  'menu.form-layouts': 'フォームレイアウト',
  'menu.form-components': 'フォームコンポーネント',
  'menu.form-validations': 'フォーム検証',
  'menu.icons': 'アイコン',
  'menu.input-groups': '入力グループ',
  'menu.jumbotron': 'ジャンボトロン',
  'menu.modal': 'モーダル',
  'menu.navigation': 'ナビゲーション',
  'menu.popover-tooltip': 'ポップオーバー & ツールチップ',
  'menu.sortable': 'ソート可能',
  'menu.tables': 'テーブル',
  'menu.menu': 'メニュー',
  'menu.subhidden': 'サブ非表示',
  'menu.hidden': '非表示',
  'menu.visible': '表示',
  'menu.maps': '地図',
  'menu.landingpage': 'ランディングページ',
  'menu.multipage-home': 'マルチページホーム',
  'menu.singlepage-home': 'シングルページホーム',
  'menu.about': 'アバウト',
  'menu.auth-login': '認証ログイン',
  'menu.auth-register': '認証登録',
  'menu.blog': 'ブログ',
  'menu.blog-detail': 'ブログ詳細',
  'menu.careers': '採用情報',
  'menu.confirmation': '確認',
  'menu.contact': 'お問い合わせ',
  'menu.docs': 'ドキュメント',
  'menu.features': '特長',
  'menu.prices': '価格',
  'menu.videos': '動画',
  'menu.mailing': 'メーリング',
  'menu.invoice': '請求書',
  'menu.blank-page': '近日公開...',
  'menu.types': 'メニュータイプ',
  'menu.levels': 'メニューレベル',
  'menu.third-level-1': '第3レベル 1',
  'menu.third-level-2': '第3レベル 2',
  'menu.third-level-3': '第3レベル 3',


  /* 04.Dashboards */
  'dashboards.update': '更新',
  'dashboards.save': '保存',
  'dashboards.pending-orders': '保留中の注文',
  'dashboards.completed-orders': '完了した注文',
  'dashboards.refund-requests': '返金リクエスト',
  'dashboards.new-comments': '新しいコメント',
  'dashboards.sales': '売上',
  'dashboards.orders': '注文',
  'dashboards.refunds': '返金',
  'dashboards.recent-orders': '最近の注文',
  'dashboards.product-categories': '商品カテゴリー',
  'dashboards.cakes': 'ケーキ',
  'dashboards.tickets': 'チケット',
  'dashboards.calendar': 'カレンダー',
  'dashboards.best-sellers': 'ベストセラー',
  'dashboards.per-session': 'セッションごと',
  'dashboards.profile-status': 'プロフィールステータス',
  'dashboards.payment-status': '支払いステータス',
  'dashboards.work-progress': '作業進捗',
  'dashboards.tasks-completed': '完了したタスク',
  'dashboards.payments-done': '完了した支払い',
  'dashboards.order-stock': '注文 – 在庫',
  'dashboards.categories': 'カテゴリー',
  'dashboards.quick-post': 'クイック投稿',
  'dashboards.title': 'タイトル',
  'dashboards.content': '内容',
  'dashboards.ticket-count': 'チケット数',
  'dashboards.commonticketsubmission': 'よくあるチケットの送信',
  'dashboards.category': 'カテゴリー',

  'dashboards.save-and-publish': '保存して公開',
  'dashboards.top-viewed-posts': '閲覧数上位の投稿',
  'dashboards.posts': '投稿',
  'dashboards.pending-for-publish': '公開待ち',
  'dashboards.users': 'ユーザー',
  'dashboards.on-approval-process': '承認プロセス中',
  'dashboards.alerts': 'アラート',
  'dashboards.waiting-for-notice': '通知待ち',
  'dashboards.files': 'ファイル',
  'dashboards.pending-for-print': '印刷待ち',
  'dashboards.logs': 'ログ',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': '細部に魔法あり',
  'dashboards.yes-it-is-indeed': 'はい、その通りです！',
  'dashboards.advanced-search': '高度な検索',
  'dashboards.toppings': 'トッピング',
  'dashboards.type': 'タイプ',
  'dashboards.keyword': 'キーワード',
  'dashboards.search': '検索',
  'dashboards.top-rated-items': '高評価アイテム',
  'dashboards.country': '国',
  'dashboards.webVisitors': 'ウェブ訪問者',
  'dashboards.avatarClicks': 'アバタークリック数',
  'dashboards.wordCloud': 'ワードクラウド',
  'dashboards.topic': 'トピックス',
  'dashboards.name': '名前',
  'dashboards.button': 'ボタン',
  'dashboards.visits': '訪問',
  'dashboards.checkAvailability': '空き状況または料金を確認',
  'dashboards.details': '詳細',
  'dashboards.roomsAvailability': '部屋と空き状況',
  'dashboards.startChat': 'チャットを開始',
  'dashboards.restaurantsBars': 'レストランとバー',
  'dashboards.groupBooking': '団体予約',
  'dashboards.promotions': 'プロモーション',
  'dashboards.weedingevents': '結婚とイベント',
  'dashboards.lostsomething': '何かを失くした',
  'dashboards.producttext': '製品テキスト',
  'dashboards.bookingroomnew': '新しい部屋を予約',
  'dashboards.email': 'メール',
  'dashboards.phone': '電話',
  'dashboards.zipcode': '郵便番号',
  'dashboards.marketingconsent': 'マーケティング同意',
  'dashboards.additionalinfo': '追加情報',
  'dashboards.viewallcontacts': 'すべての連絡先を見る',
  'dashboards.current': '現在',
  'dashboards.last7days': '過去7日間',
  'dashboards.last30days': '過去30日間',
  'dashboards.thisweek': '今週',
  'dashboards.thismonth': '今月',
  'dashboards.previousmonth': '前月',
  'dashboards.yeartodate': '年初以来',
  'dashboards.lastyear': '昨年',
  'dashboards.all': 'すべて',
  'dashboards.standardOccupancy': '標準収容人数',
  'dashboards.max-occupancy': '最大収容人数"',
  'dashboards.numberOfThisType': 'このタイプの数',
  'dashboards.displayOrder': '表示順',
  'dashboards.provider': '提供者',
  'dashboards.edit': '編集',
  'dashboards.delete': '削除',
  'dashboards.addImages': '画像を追加',
  'dashboards.location_ip': 'IPアドレスに基づく推定位置',
  'dashboards.near': '近く',
  'dashboards.referral': 'このウェブサイト経由でページに来たユーザー',
  'dashboards.calling_party': '発信ユーザー',
  'dashboards.called_party': '着信ユーザー',
  'dashboards.lastdial': '直近の発信',
  'dashboards.imagelink': '画像リンク',
  'dashboards.browsegallery': 'ギャラリーを閲覧',
  'dashboards.changelog': '変更履歴',
  'dashboards.externalresources': '外部リソース',
  'dashboards.webpage': 'ウェブページ',
  'dashboards.web-pages': 'ウェブページ',
  'dashboards.published': '公開済み',
  'dashboards.adddocument': 'ドキュメントを追加',
  'dashboards.ready-to-publish': '公開準備完了',
  'dashboards.draft': '下書き',
  'dashboards.order-by': '並び替え',
  'dashboards.add-faq': 'FAQを追加',
  'dashboards.collections': 'コレクション',

  'dashboards.items': 'アイテム',
  'dashboards.rooms-availability': '部屋と空室状況',
  'dashboards.events-wedding-venues': 'イベントと結婚式場',
  'dashboards.long-stay-enquiry': '長期滞在のお問い合わせ',
  'dashboards.reservation-confirmation-request': '予約確認のリクエスト',
  'dashboards.modify-cancel-booking': '予約の変更またはキャンセル',
  'dashboards.left-something-behind': '忘れ物',
  'dashboards.invoice-copy': '請求書 / 領収書のコピー',
  'dashboards.sync': '同期',
  'dashboards.add-web-page': 'ウェブページを追加',
  'dashboards.sprint-title': 'Sprint をご紹介します。AI モデルを 10 倍速くトレーニングする画期的な自動化機能です。',
  'dashboards.sprint-description': 'Sprint はあなたと共に機能し、創造性を解き放ち、生産性を高め、デジタルアシスタントのトレーニングにかかる時間を劇的に短縮します。',
  'dashboards.sprint-feature': 'Sprint 機能は外部ソースから知識を同期するよう設計されており、初期設定および継続的なデータ更新の両方に有用です。アクティブなシステムで実行されると、Sprint は設定された外部ソースに基づいて Knowledge Hub を変更し、AI が生成する動作や応答に直接影響を与える可能性があります。Sprint の設定については、サポートチームにお問い合わせください。',
  'dashboards.change-password': 'パスワードを変更',
  'dashboards.sign-out': 'サインアウト',
  'dashboards.privacy-policy': 'プライバシーポリシー',
  'dashboards.help-center': 'ヘルプセンター',
  'dashboards.switch-account': 'アカウントを切り替え',
  'dashboards.business-settings': 'ビジネス設定',
  'dashboards.notifications-allowed': '通知が許可されました',
  'dashboards.dark-theme': 'ダークテーマ',
  'dashboards.online': 'オンライン',
  'dashboards.offline': 'オフライン',
  'dashboards.invoice-&-payments': '請求書と支払い',
  'dashboards.upgrade-plan': 'プランをアップグレード',
  'dashboards.add-room': '部屋を追加',
  'dashboards.room-type': '部屋タイプ',
  'dashboards.room-name': '部屋名',
  'dashboards.how-many-guests': 'この部屋に何人宿泊できますか？',
  'dashboards.number-of-rooms-this-type': '部屋数（このタイプ）',
  'dashboards.number-of-bedrooms': '寝室数',
  'dashboards.number-of-livingrooms': 'リビングルーム数',
  'dashboards.minimum-adults': '最小大人数',
  'dashboards.maximum-adults': '最大大人数',
  'dashboards.maximum-children': '最大子供人数',
  'dashboards.maximum-infants': '最大乳児人数',
  'dashboards.extra-beds-allowed': 'エキストラベッド許可',
  'dashboards.booking-engine-code': '予約エンジンコード',
  'dashboards.room-size': '部屋のサイズ',
  'dashboards.balcony-area': 'バルコニー面積',
  'dashboards.unit': '単位',
  'dashboard.whatsapp_message': 'ここにメッセージを入力してください...',
  'dashboard.whatsapp_reply_window': 'WhatsApp Businessでは、顧客が最後にメッセージを送信してから24時間以内に返信する必要があります。この24時間のカスタマーケアウィンドウ内で返信した場合、あらゆる種類のメッセージを送信できます。24時間を過ぎると、事前に承認されたメッセージテンプレートのみ送信可能となり、顧客が返信すると24時間ウィンドウが再開されます。',
  'dashboards.square-meters': '平方メートル',
  "dashboard.pick_quick_reply": "クイック返信を選択するか、メッセージを入力してください",
  "dashboard.hang_in_there": "接続を試みています。しばらくお待ちください。",
  "dashboard.outbound_msg": "送信メッセージの送信タイミング",
  "dashboard.message_sent": "メッセージは正常に送信されました！",
  "dashboard.failed_msg": "メッセージの送信に失敗しました",
  "dashboard.new_chat_message": "新しいチャットメッセージ",
  "dashboard.user_msg": "過去24時間以内にユーザーメッセージがあります。どのメッセージでも返信できます。このテンプレートメッセージを送信しますか、それとも別のメッセージで返信しますか？",
  "dashboard.us_number": "Meta が 2025年4月1日に米国番号へのすべてのマーケティングメッセージを一時停止したため、WhatsApp Business メッセージは米国番号に送信されません。",
  "dashboard.error_msg": "すべてのプレースホルダーを正しく入力してください。",

  'web-widget.title': 'ウェブサイトチャットボットのウィジェットメニュー',
  /*Home page*/
  'dashboards.quickstartwithai': 'AIを使ったクイックスタート',
  'dashboards.fastestpathtoautomation': 'AIツールで自動化への最速の道を進んでいます',
  'dashboards.insightsthatempower': '力を与えるインサイト',
  'dashboards.trainchatbot': 'チャットボットをトレーニング',
  'dashboards.automatewithforms': 'フォームで自動化',
  'dashboards.inroomdigitalcompendium': '客室内デジタルコンペンディウム',
  'dashboards.support': 'サポート',
  'dashboards.helpcenter': 'ヘルプセンター',
  'dashboards.searchfaqintegrations': 'よくあるFAQ、統合機能などに関する記事を検索',
  'dashboards.asklivechat': 'ライブチャットでチームに質問する',
  'dashboards.inroomqrcode': '客室内のQRコードで施設や場所の情報を見る',
  'dashboards.customizewebwidget': 'AIチャットボットを統合したウェブウィジェットをサイトにカスタマイズして追加',
  'dashboards.createcustomforms': 'カスタムフォームを作成し、ゲストがフォームを送信したときに通知を受ける',
  'dashboards.trainchatbotproperty': 'チェックイン時間やアクティビティなど、物件に関する情報でチャットボットをトレーニング',
  'dashboards.chatbotinsights': 'チャットボットがゲストとどのように対話しているかを確認し、ウェブサイト訪問者、よくある質問などの統計を把握',
  'dashboards.addaichatbottoyourwebsite': 'WebサイトにAIチャットボットを追加',

  /* メール統計 */
  'dashboards.thread-summary-title': 'スレッド要約',
  'dashboards.thread-summary-subtitle': 'AIによって生成されたメール要約',
  'dashboards.ai-replies-title': 'AI返信',
  'dashboards.ai-replies-subtitle': 'AIによって生成された返信',

  'dashboards.total-thread-summary-title': '生成されたスレッド要約の合計',
  'dashboards.total-ai-replies-title': '生成されたAI返信の合計',
  'dashboards.total-draft-copied': 'ユーザーによってコピーされた下書き',

  'dashboards.urgency': '緊急度',
  'dashboards.sentiment': '感情分析',

  'dashboards.common-email-reasons': 'よくあるメールの理由',
  'dashboards.topics-in-emails': 'メール内のトピック',

  'dashboards.email-assistant-usage': 'AIメールアシスタントの利用状況',
  'dashboards.usage-by-email-address': 'メールアドレス別の利用状況',

  /* 05.Pages */
  'pages.title.dashboards.analytics': '分析',
  'pages.title.ari': '空室状況と料金',
  'pages.title.conversations': '会話',
  'pages.title.bookings': '予約とブッキング',
  'pages.title.tickets': 'リードとチケット',
  'pages.title.propinfo': '回答',
  'pages.title.discounts': '割引とプロモーション',
  'pages.title.finance': '財務',
  'pages.title.integration': '統合',
  'pages.title.admin': '管理者',
  'pages.add-new': '新規追加',
  'pages.add-new-modal-title': '新しい項目を追加',
  'pages.display-options': '表示オプション',
  'pages.orderby': '並び順：',
  'pages.product-name': '商品名',
  'pages.category': 'カテゴリー',
  'pages.description': '説明',
  'pages.status': 'ステータス',
  'pages.cancel': 'キャンセル',
  'pages.submit': '送信',
  'pages.delete': '削除',
  'pages.another-action': 'その他の操作',
  'pages.actions': '操作',
  'pages.header': 'ヘッダー',
  'pages.details': '詳細',
  'pages.orders': '注文',
  'pages.rating': '評価',
  'pages.price': '価格',
  'pages.ingredients': '材料',
  'pages.is-vegan': 'ヴィーガンですか',
  'pages.order-status': '注文ステータス',
  'pages.bake-progress': '焼成進行状況',
  'pages.popularity': '人気度',
  'pages.comments': 'コメント',
  'pages.error-title': 'おっと…エラーが発生したようです！',
  'pages.error-code': 'エラーコード',
  'pages.go-back-home': 'ホームに戻る',
  'pages.mailing-info': 'メールテンプレートは、さまざまなサービスプロバイダーで適切に表示されるように、インラインスタイルとテーブルレイアウトを使用しています。より使いやすくするため、通常のHTMLとしてdangerouslySetInnerHTMLを使用して組み込まれています。',
  'pages.invoice-info': '請求書テンプレートには、プロジェクト外でも使用できるインラインスタイルバージョンとReactバージョンの両方があります。',
  'pages.react-version': 'Reactバージョン',
  'pages.inline-version': 'インラインスタイルHTMLバージョン',


  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'メッセージ',
  'chat.contacts': '連絡先',
  'chat.saysomething': '何か言って..',

  /* 06.02.Survey */
  'survey.delete': '消去',
  'survey.edit': '編集',
  'survey.add-new': '新しく追加する',
  'survey.add-new-title': '新しいアンケートを追加',
  'survey.title': 'タイトル',
  'survey.category': 'カテゴリー',
  'survey.label': 'ラベル',
  'survey.status': '状態',
  'survey.cancel': 'キャンセル',
  'survey.submit': '提出する',
  'survey.another-action': '別のアクション',
  'survey.display-options': '表示オプション',
  'survey.orderby': '注文方法:',
  'survey.all-surveys': 'すべてのアンケート',
  'survey.completed-surveys': '完了したアンケート',
  'survey.categories': 'カテゴリー',
  'survey.active-surveys': 'アクティブなアンケート',
  'survey.labels': 'ラベル',

  /* 06.03.Todo */
  'todo.add-new': '新規追加',
  'todo.add-new-title': '新しい予定を追加',
  'todo.title': 'タイトル',
  'todo.detail': '詳細',
  'todo.category': 'カテゴリ',
  'todo.label': 'ラベル',
  'todo.status': 'ステータス',
  'todo.cancel': 'キャンセル',
  'todo.submit': '送信',
  'todo.action': '操作',
  'todo.another-action': 'その他の操作',
  'todo.display-options': '表示オプション',
  'todo.orderby': '並び順：',
  'todo.all-tasks': '全タスク',
  'todo.pending-tasks': '保留中のタスク',
  'todo.completed-tasks': '完了したタスク',
  'todo.categories': 'カテゴリ一覧',
  'todo.labels': 'ラベル一覧',


  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': '角丸アラート',
  'alert.react-notifications': 'React 通知',
  'alert.outline': 'アウトライン',
  'alert.primary': 'プライマリー',
  'alert.secondary': 'セカンダリー',
  'alert.info': 'インフォ',
  'alert.success': '成功',
  'alert.warning': '警告',
  'alert.error': 'エラー',
  'alert.filled': '塗りつぶしアラート',
  'alert.primary-text': 'これはプライマリーアラートです—ご確認ください！',
  'alert.secondary-text': 'これはセカンダリーアラートです—ご確認ください！',
  'alert.success-text': 'これは成功アラートです—ご確認ください！',
  'alert.danger-text': 'これは危険アラートです—ご確認ください！',
  'alert.warning-text': 'これは警告アラートです—ご確認ください！',
  'alert.info-text': 'これはインフォアラートです—ご確認ください！',
  'alert.light-text': 'これはライトアラートです—ご確認ください！',
  'alert.dark-text': 'これはダークアラートです—ご確認ください！',
  'alert.default': 'デフォルトアラート',
  'alert.dismissing': '閉じることができるアラート',
  'alert.dismissing-text': 'うわっ！いくつかの項目をチェックしたほうがよさそうです。',
  'alert.dismissing-without-animate-text': 'このアラートはアニメーションなく閉じることができます！',



  /* 07.02.Badges */
  'badge.sizes': 'サイズ',
  'badge.colors': 'カラー',
  'badge.outline': 'アウトライン',
  'badge.links': 'リンク',
  'badge.counter-badges': 'カウンターバッジ',
  'badge.bootstrap-default': 'Bootstrap デフォルト',
  'badge.primary': 'プライマリー',
  'badge.secondary': 'セカンダリー',
  'badge.success': '成功',
  'badge.danger': '危険',
  'badge.warning': '警告',
  'badge.info': 'インフォ',
  'badge.light': 'ライト',
  'badge.dark': 'ダーク',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap デフォルト',
  'button.colors': 'カラー',
  'button.rounded': '角丸',
  'button.outline': 'アウトライン',
  'button.states': '状態',
  'button.sizes': 'サイズ',
  'button.button-groups': 'ボタングループ',
  'button.large-button': '大ボタン',
  'button.small-button': '小ボタン',
  'button.extra-small-button': '超小ボタン',
  'button.block-button': 'ブロックボタン',
  'button.active': 'アクティブ',
  'button.disabled': '無効',
  'button.basic': 'ベーシック',
  'button.toolbar': 'ツールバー',
  'button.nesting': '入れ子',
  'button.vertical-variation': '垂直バリエーション',
  'button.checkbox-radio-button': 'チェックボックス & ラジオボタン',
  'button.checkbox': 'チェックボックス',
  'button.radio': 'ラジオ',
  'button.radio-button': 'ラジオボタン',
  'button.primary': 'プライマリー',
  'button.secondary': 'セカンダリー',
  'button.success': '成功',
  'button.danger': '危険',
  'button.warning': '警告',
  'button.info': 'インフォ',
  'button.light': 'ライト',
  'button.dark': 'ダーク',
  'button.states-text': 'このボタンは2秒間スピナーを表示し、その後3秒間エラーアイコンを表示してから通常状態に戻ります。状態はクラスの追加と削除で制御できます。',
  'button.click-here': 'ここをクリック',
  'button.states-text-alternate': 'このボタンは2秒間スピナーを表示し、その後3秒間エラーアイコンを表示してから通常状態に戻ります。状態はクラスの追加と削除で制御できます。',
  'button.primary-link': 'プライマリーリンク',
  'button.link': 'リンク',
  'button.primary-button': 'プライマリーボタン',
  'button.button': 'ボタン',
  'button.left': '左',
  'button.middle': '中央',
  'button.right': '右',
  'button.dropdown': 'ドロップダウン',
  'button.dropdown-link': 'ドロップダウンリンク',


  /* 07.04.Cards */
  'cards.icon-card': 'アイコンカード',
  'cards.image-card': '画像カード',
  'cards.image-overlay-card': '画像オーバーレイカード',
  'cards.image-card-list': '画像カードリスト',
  'cards.tab-card': 'タブカード',
  'cards.user-card': 'ユーザーカード',

  /* 07.05.Carousel */
  'carousel.basic': '基本カルーセル',
  'carousel.single': 'シングルカルーセル',
  'carousel.without-controls': '操作なしカルーセル',

  /* 07.06.Charts */
  'charts.line': '折れ線グラフ',
  'charts.polar': 'ポーラーチャート',
  'charts.area': '面グラフ',
  'charts.scatter': '散布図',
  'charts.bar': '棒グラフ',
  'charts.radar': 'レーダーチャート',
  'charts.pie': '円グラフ',
  'charts.doughnut': 'ドーナツチャート',
  'charts.shadow': '影あり',
  'charts.no-shadow': '影なし',


  /* 07.07.Collapse */
  'collapse.basic': '基本',
  'collapse.toggle': 'トグル',
  'collapse.accordion': 'アコーディオン',
  'collapse.controlled': '制御付き',
  'collapse.uncontrolled': '非制御',

  /* 07.08.Dropdowns */
  'dropdowns.basic': '基本',
  'dropdowns.controlled': '制御付き',
  'dropdowns.uncontrolled': '非制御',
  'dropdowns.dropdown': 'ドロップダウン',
  'dropdowns.header': 'ヘッダー',
  'dropdowns.action': '操作',
  'dropdowns.another-action': '別の操作',
  'dropdowns.right': '右',
  'dropdowns.left': '左',
  'dropdowns.drop-directions': 'ドロップ方向',
  'dropdowns.dropright': 'ドロップライト',
  'dropdowns.dropleft': 'ドロップレフト',
  'dropdowns.small-button': '小ボタン',
  'dropdowns.large-button': '大ボタン',
  'dropdowns.sizing': 'サイズ調整',
  'dropdowns.split-button': '分割ボタン付きドロップダウン',
  'dropdowns.dropup': 'ドロップアップ',


  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill 標準',
  'editors.quill-bubble': 'Quill バブル',

  /* 07.10.Forms */
  'forms.basic': '基本',
  'forms.email': 'メールアドレス',
  'forms.email-muted': 'メールは他人と共有されることはありません。',
  'forms.password': 'パスワード',
  'forms.submit': '送信',
  'forms.horizontal': '横並び',
  'forms.radios': 'ラジオ',
  'forms.first-radio': '最初のラジオ',
  'forms.second-radio': '2番目のラジオ',
  'forms.third-radio-disabled': '3番目（無効）ラジオ',
  'forms.checkbox': 'チェックボックス',
  'forms.signin': 'サインイン',
  'forms.top-labels-over-line': '上部ラベル（ライン上）',
  'forms.tags': 'タグ',
  'forms.date': '日付',
  'forms.state': '州／都道府県',
  'forms.top-labels-in-input': '上部ラベル（入力内）',
  'forms.email-u': 'メール',
  'forms.password-u': 'パスワード',
  'forms.tags-u': 'タグ',
  'forms.date-u': '日付',
  'forms.state-u': '州／都道府県',
  'forms.grid': 'フォームグリッド',
  'forms.address': '住所',
  'forms.address2': '住所 2',
  'forms.city': '市区町村',
  'forms.city-message': '市区町村を選択してください！',
  'forms.state-message': '都道府県を選択してください！',
  'forms.zip': '郵便番号',
  'forms.signup': '登録',
  'forms.inline': 'インライン',
  'forms.validation-availity': 'Availity Reactstrap 検証',
  'forms.validation-formik': 'Formik 検証',
  'forms.default': 'デフォルト',
  'forms.firstname': '名',
  'forms.firstname-message': '名を入力してください！',
  'forms.lastname': '姓',
  'forms.lastname-message': '姓を入力してください！',


  /* 07.11.Form Components */
  'form-components.custom-inputs': 'カスタム入力',
  'form-components.checkboxes': 'チェックボックス',
  'form-components.radios': 'ラジオ',
  'form-components.inline': 'インライン',
  'form-components.react-select': 'Reactセレクト',
  'form-components.state-single': '単一ステート',
  'form-components.state-multiple': '複数ステート',
  'form-components.react-autosuggest': 'React自動補完',
  'form-components.date-picker': '日付ピッカー',
  'form-components.date': '日付',
  'form-components.date-range': '日付範囲',
  'form-components.date-with-time': '日時',
  'form-components.embedded': '埋め込み',
  'form-components.dropzone': 'ドロップゾーン',
  'form-components.drop-files-here': 'ここにファイルをドロップ',
  'form-components.tags': 'タグ',
  'form-components.switch': 'スイッチ',
  'form-components.primary': 'プライマリー',
  'form-components.secondary': 'セカンダリー',
  'form-components.primary-inverse': 'プライマリー（反転）',
  'form-components.secondary-inverse': 'セカンダリー（反転）',
  'form-components.slider': 'スライダー',
  'form-components.double-slider': 'ダブルスライダー',
  'form-components.single-slider': 'シングルスライダー',
  'form-components.rating': '評価',
  'form-components.interactive': 'インタラクティブ',
  'form-components.readonly': '読み取り専用',
  'form-components.type-a-cake': 'ケーキを入力',
  'form-components.start': '開始',
  'form-components.end': '終了',
  'form-components.tables': 'テーブル',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': '基本',
  'input-groups.sizing': 'サイズ調整',
  'input-groups.small': '小',
  'input-groups.default': 'デフォルト',
  'input-groups.large': '大',
  'input-groups.checkboxes-and-radios': 'チェックボックスとラジオ',
  'input-groups.multiple-inputs': '複数入力',
  'input-groups.first-and-last-name': '名と姓',
  'input-groups.multiple-addons': '複数アドオン',
  'input-groups.button-addons': 'ボタンアドオン',
  'input-groups.button': 'ボタン',
  'input-groups.buttons-with-dropdowns': 'ドロップダウン付きボタン',
  'input-groups.dropdown': 'ドロップダウン',
  'input-groups.header': 'ヘッダー',
  'input-groups.action': '操作',
  'input-groups.another-action': '別の操作',
  'input-groups.custom-select': 'カスタムセレクト',
  'input-groups.options': 'オプション',
  'input-groups.choose': '選択…',
  'input-groups.custom-file-input': 'カスタムファイル入力',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'こんにちは、世界！',
  'jumbotron.lead': 'これは、注目度を高めたいコンテンツのための簡単なヒーローユニット、いわゆるジャンボトロンスタイルのコンポーネントです。',
  'jumbotron.lead-detail': 'タイポグラフィと余白のユーティリティクラスを使って、コンテナ内のコンテンツに余白を持たせています。',
  'jumbotron.learn-more': '詳しく読む',

  /* 07.15.Modal */
  'modal.basic': '基本',
  'modal.modal-title': 'モーダルタイトル',
  'modal.launch-demo-modal': 'デモモーダルを開く',
  'modal.scrolling-long-content': '長いコンテンツ（スクロール）',
  'modal.backdrop': 'バックドロップ',
  'modal.backdrop-value': 'バックドロップ値',
  'modal.right-modal': '右側モーダル',
  'modal.launch-right-modal': '右側モーダルを開く',
  'modal.nested-modal': 'ネストされたモーダル',
  'modal.size': 'サイズ',
  'modal.launch-large-modal': '大モーダルを開く',
  'modal.launch-small-modal': '小モーダルを開く',

  /* 07.16.Navigation */
  'nav.basic': 'ナビ基本',
  'nav.active': 'アクティブ',
  'nav.disabled': '無効',
  'nav.disabled-link': '無効リンク',
  'nav.link': 'リンク',
  'nav.longer-link': '長めのリンク',
  'nav.another-link': '別のリンク',
  'nav.right': '右',
  'nav.dropdown': 'ドロップダウン',
  'nav.header': 'ヘッダー',
  'nav.action': '操作',
  'nav.another-action': '別の操作',
  'nav.horizontal-alignment': 'ナビ水平配置',
  'nav.vertical-alignment': 'ナビ垂直配置',
  'nav.pills': 'ナビピル',
  'nav.fill-justify': 'フィル＆均等配置',
  'nav.pills-dropdowns': 'ドロップダウン付きピル',
  'nav.pagination-basic': 'ページ基礎',
  'nav.pagination-sizing': 'ページサイズ調整',
  'nav.large': '大',
  'nav.small': '小',
  'nav.center': '中央',
  'nav.pagination-alignment': 'ページ配置',
  'nav.breadcrumb-basic': 'パンくず基礎',


  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'ポップオーバー',
  'popover-tooltip.tooltip': 'ツールチップ',

  /* 07.18.Sortable */
  'sortable.columns': 'ソート可能な列',
  'sortable.basic': '基本',
  'sortable.handles': 'ハンドル',


  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',


  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrapテーブル',
  'table.bootstrap-basic': 'ベーシックテーブル',
  'table.bootstrap-striped': 'ストライプ行',
  'table.bootstrap-bordered': '枠付きテーブル',
  'table.bootstrap-borderless': '枠なしテーブル',
  'table.bootstrap-hoverable': 'ホバー可能な行',
  'table.bootstrap-responsive': 'レスポンシブテーブル',
  'table.react-tables': 'Reactテーブル',
  'table.react-pagination': 'ページネーション',
  'table.react-scrollable': 'スクロール可能',
  'table.react-advanced': 'フィルター・数・ジャンプ',


  /* Property Info */
  "property-info.allcustomers": 'すべての顧客',
  'property-info.external-sources': '外部ソース',
  'property-info.faq': 'よくある質問',
  'property-info.documents': 'ドキュメント',
  'property-info.publish-ai': 'AIで公開',
  'property-info.pre-built-templates': '事前構築済みテンプレート',
  'property-info.room-types': '部屋タイプ',

  'property-info.about-property': '物件について',
  'property-info.about-properties': 'プロパティについて',
  'property-info.facilities-services': '施設とサービス',
  'property-info.property-facilities': '物件設備',
  'property-info.room-amenities': '部屋のアメニティ',
  'property-info.property-contact': '物件連絡先',
  'property-info.property-activities': '財産活動',
  'property-info.property-location': '物件の所在地',
  'property-info.about-rooms': '部屋',
  'property-info.about-sites': 'サイトについて',
  'property-info.special-emergencies': '緊急事態',
  'property-info.gallery': 'ギャラリー',
  'property-info.policies': 'ポリシー',
  'property-info.nearby': '近く',
  'property-info.transport': '輸送',
  'property-info.location': '位置',
  'property-info.about-rhproperty': '老人ホームについて',
  'property-info.related-topics': '関連トピック',
  'property-info.assistant-options': 'アシスタントメニュー',
  'property-info.restaurant-assistant-information': 'レストラン情報',
  'property-info.restaurant-assistant-options': 'ウェルカムメッセージ',
  'property-info.channel-messages': 'チャンネルメッセージ',
  'property-info.icon.gallery': 'アイコンギャラリー',
  'property-info.copilot': '副操縦士',
  'property-info.sprint': 'スプリント',
  'property-info.home-information': 'ホーム情報',
  'property-info.loction': '所在地',
  'property-info.rooms-and-images': '部屋とイメージ',
  'property-info.trainig-data': 'トレーニングデータ',
  'property-info.flows': '流れ',
  'property-info.add-your-own': '独自のものを追加',
  'property-info-utility-miscellaneous': 'その他',
  'property-info-utility-payment': '支払い',
  'property-info-utility-broadband': 'ブロードバンド',
  'property-info-utility-emergency': '緊急',
  'property-info-utility-mobile': '携帯',
  'property-info-utility-moving': '移動',
  'property-info.publishMonitor': '公開とモニター',
  'property-info.webWidget': 'ウェブウィジェット',
  'property-info.media': 'メディア',
  /** Rate & Promo */
  'rate-promo.rate-plans': '料金プラン',
  'rate-promo.rate-plan-addons': 'アドオン',
  'rate-promo.rate-plan-promos': 'プロモーション',

  'title.property-information': '物件情報',

  'property.message': 'メッセージ',
  'property.example': '例',
  'property.link': 'リンク',
  'property.image-carousel': '画像カルーセル',
  'property.Title': 'タイトル',
  'property.SubTitle': 'サブタイトル',

  'property.add-invoke-api': 'APIの呼び出し',
  'property.add-message-button': 'メッセージの追加',
  'property.add-img-button': '画像の追加',
  'property.add-link-button': 'リンクを追加',
  'property.add-herocard-button': 'ヒーローカードを追加',
  'property.add-api-button': 'ボタンの追加',

  'menu.settings': '設定',
  'menu.workflows': 'ワークフロー',
  'menu.product_services': 'プロダクト＆サービス',
  'menu.product_recommander': '製品レコメンダー',
  'menu.digital_guide_book': 'デジタルガイドブック',
  'menu.welcome_message': '歓迎メッセージ',
  'menu.about-property': '施設について',
  'menu.property-facilities': '施設の設備',
  'menu.room-amenities': '部屋のアメニティ',
  'menu.property-contact': '施設の連絡先',
  'menu.about-rooms': '部屋について',
  'menu.special-emergencies': '緊急時の対応',
  'menu.show-filter': 'フィルターを表示',
  'menu.new': '新規',
  'menu.channel': 'チャンネル',
  'menu.application': 'アプリケーション',

  'dashboards.send': '送信',
  'dashboards.hello': 'こんにちは',
  'dashboards.notificationsAllowed': '通知が許可されました',
  'dashboards.allowNotifications': '通知を許可する',
  'dashboards.views': 'ビュー',
  'dashboards.bookingURL': '予約 URL',
  'dashboards.searchTags': '検索タグ',
  'dashboards.searchCategoryTags': '検索カテゴリタグ',
  'dashboards.bedroom': '寝室',
  'dashboards.addBedroom': '寝室を追加',
  'dashboards.frequency': '頻度',
  'dashboards.includeSubpages': 'サブページを含める',
  'dashboards.enableFaqs': 'FAQ を有効にする',
  'dashboards.faqsDescription': 'FAQ を有効にすると、システムが Web ページの内容から対応する回答を抽出して完全な FAQ を作成できるように、質問を入力できるようになります',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'ドキュメントを削除',
  'dashboards.confirmDelete': '本当に削除しますか？',
  'dashboards.addItem': '項目を追加',
  'dashboards.addFirstWebPage': 'あなたの最初の Web ページを追加',


  'dashboards.popular-compendium': '人気のコンペンディウムメニュー項目',
  'dashboards.wordcloudofcompendium': '	コンペンディウムメニュー項目のワードクラウド',
  'dashboards.wordcloudonthings': 'ウェブサイト訪問者の質問とメニュー項目に関するワードクラウド',
  'dashboards.common-asked': 'よくある質問',
  'dashboards.website-visitor-asking': 'ウェブサイト訪問者が質問していること',
  'dashboards.visit-country': '国別のウェブサイト訪問数',
  'dashboards.visit-traffic': 'Web サイトのトラフィックの国',
  'dashboards.rooms-product': '客室と製品',
  'dashboards.popular-room-product': '人気のお部屋と商品',

  'dashboards.messenger-stats': '人気メニュー',
  'dashboards.messenger-stats-topic-view': 'メニュー項目ビューの統計',
  'dashboards.messenger-stats-visits': 'メニュー項目のビュー',
  'dashboards.opening-menu-items': 'メニュー項目を開いた Web サイト訪問者の数',

  'dashboards.number-totalavatarclick': 'アバターの合計クリック数',
  'dashboards.tickets-by-category': 'カテゴリ別チケット',
  'dashboards.download': 'ダウンロード',
  'dashboards.clicks': 'クリック数',
  'dashboards.leads': 'リード',
  'dashboards.hours': '時間',
  'dashboards.minutes': '分',
  'dashboards.connect': '接続',
  'dashboards.subscribe-to-reports': 'レポートを購読する',
  'dashboards.ai-chatbot': 'AIチャットボット',
  'dashboards.compendium': '概要',
  'dashboards.compendium-digital-usage': 'デジタル大要の使用法',
  'dashboards.compendium-unique-visits': 'QRコードのスキャン/クリック',
  'dashboards.compendium-opening-menu-items': '閲覧されたメニュー項目の数',
  'dashboards.compendium-total-digital-clicks':
    'メニュー項目の合計閲覧数',
  'dashboards.compendium-total-qr-code': 'QRコードスキャン/クリック数合計',
  'dashboards.compendium-avg-menu-items': 'スキャンあたりの平均メニュー項目表示回数',


  'property.delete': '消去',
  'menu.userroles': 'ユーザーと役割',
  'menu.members': 'メンバー',
  'menu.guest-pass': 'ゲストパス',
  'menu.ratebookings': '料金と予約',
  'dashboards.engagement-time': 'デジタル アシスタントのエンゲージメント時間',
  'dashboards.conversations-minutes':
    '合計分と夜間（午後 7 時から午前 7 時まで）の会話時間（分）',
  'dashboards.visitor-questions': '訪問者の質問',
  'dashboards.recent-queries': '最近のクエリ',
  'dashboards.visitor-saying': '訪問者がデジタル アシスタントに言ったこと',
  'dashboards.contacts-prechatform-leavemessage':
    'プレチャットフォームから保存された連絡先とメッセージを残す',
  'menu.dashboards': 'インサイト',
  'menu.ari': '空室状況と料金',
  'menu.conversations': '会話',
  'menu.conversations.unified-inbox': '受信トレイ',
  'menu.conversations.active': 'アクティブなチャット',
  'menu.conversations.archives': 'アーカイブ',
  'menu.conversations.missed-responses': '未返信',
  'menu.conversations.ticket': 'チケット',
  'menu.conversations.reply-templates': '返信テンプレート',
  'menu.bookings': '予約と予約',
  'menu.tickets': 'リードとチケット',
  'menu.propinfo': 'ナレッジハブ',
  'menu.rate-promos': '料金とプロモーション',
  'menu.finance': 'ファイナンス',
  'menu.integration': '接続する',
  'menu.admin': '管理者とセキュリティ',
  'menu.favourites': 'お気に入り',
  'menu.recommender': '会話の流れ',
  'menu.assistant-setup': 'アシスタントのセットアップ',
  'menu.admin-insights': '管理者の洞察',
  'menu.super-admin': 'スーパー管理者',
  'menu.groups': 'グループ',
  'menu.properties': 'プロパティ',
  'menu.service-provider': 'サービスプロバイダー',
  'menu.spaces': 'スペース',
  'menu.content-manager': 'コンテンツマネージャー',
  'menu.events-calendar': 'イベントカレンダー',
  'menu.appearance-settings': '外観と設定',
  'menu.availability': '利用可能性',
  'menu.help': 'ヘルプ',
  'menu.myAccounts': 'マイアカウント',
  // Main menu and submenus
  'menu.guest-messaging': 'ゲストメッセージ',
  'guest-messaging.settings': '設定',
  'guest-messaging.outreach-setup': 'アウトリーチ設定',
  'guest-messaging.reservations': '予約',
  'guest-messaging.insights_logs': 'インサイトとログ',


  // Section placeholders
  'guest-messaging.placeholder': 'ゲストメッセージ機能は近日公開予定です。',
  'guest-messaging.settings.placeholder': 'ゲストメッセージの設定を行います。',
  'guest-messaging.outreach.placeholder': 'アウトリーチキャンペーンやテンプレートを設定します。',
  'guest-messaging.reservations.placeholder': '予約メッセージを管理します。',

  // Guest Messaging Settings Tabs
  'guest-messaging.reservation-source': '予約データ元',
  'guest-messaging.communication-channels': 'コミュニケーションチャネル',
  'guest-messaging.templates': 'テンプレート',
  'guest-messaging.link': 'リンク',
  'guest-messaging.business-profile': 'ビジネスプロフィール',

  'dashboards.space-booking': 'スペースの予約',
  'dashboards.gift-voucher': 'ギフト券',
  'dashboards.chatbots': 'チャットボット',
  'dashboards.form': 'から',
  'dashboards.to': 'に',
  'dashboards.active-groups': 'アクティブなグループ',
  'dashboards.active-properties': 'アクティブなプロパティ',
  'dashboards.live-properties': 'ライブプロパティ',
  'dashboards.properties-going': '日付範囲ごとに公開されるプロパティ',
  'dashboards.start-date': '開始日',
  'dashboards.end-date': '終了日',
  'dashboards.all-properties-with': 'ステータスが「ライブ」のすべての施設',
  'dashboards.aibot-by-country': '国別のAIチャットボット利用クライアント',
  'dashboards.list-live-clients': 'AIチャットボットを利用中のライブクライアント一覧',

  'dashboards.website-visits': 'ウェブサイトの訪問数',
  'dashboards.unique-visitors': 'ユニークな訪問者',
  'dashboards.last-week': '先週',
  'dashboards.this-week': '今週',
  'dashboards.this-month': '今月',
  'dashboards.previous-month': '前月',
  'dashboards.yeartodate': '年初来',
  'dashboards.lastyear': '去年',
  'dashboards.last-7-days': '過去 7 日間',
  'dashboards.last-30-days': '過去 30 日間',
  'dashboards.last-60-days': '過去60日間',
  'dashboards.last-90-days': '過去90日間',
  'dashboards.conversion-rates': 'コンバージョン率',
  'dashboards.digital-assistant-engagement': 'デジタル アシスタントの関与',
  'dashboards.total-overnight-conversations':
    '合計および一晩（午後 7 時から午前 7 時まで）の会話',
  'dashboards.percentage-accuracy': '精度を理解する',
  'dashboards.percentage-conversion':
    'Web サイトのトラフィックからチャットへの変換',
  'dashboards.percentage-avatarclick':
    'アバタークリックへのウェブサイトトラフィック',
  'dashboards.percentage-negativefeedback':
    'アバターのクリック数に占める否定的なフィードバックの割合',
  'dashboards.percentage-amenties': 'アメニティに関する問い合わせ',
  'dashboards.percentage-booking': '予約に関するお問い合わせ',
  'dashboards.percentage-webchats': 'ウェブサイトチャット',
  'dashboards.percentage-facebookchat': 'Facebook チャット',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': '合計会話時間',
  'dashboards.number-totalconversation': '総会話数',
  'dashboards.number-websiteconversation': 'ウェブサイトでの会話',
  'dashboards.number-facebookconversation': 'Facebookでの会話',
  'dashboards.number-estimatedtimesaving': '推定時間の節約',
  'dashboards.number-googlemapsconversation': 'Google マップでの会話',
  'dashboards.number-whatsappconversation': 'WhatsApp での会話',
  'dashboards.number-instagramconversation': 'インスタグラムでの会話',
  'dashboards.number-agentconversation': 'エージェントの会話',
  'dashboards.number-amenityqueries': 'アメニティに関する問い合わせ',
  'dashboards.number-bookingenquiries': '予約に関する問い合わせ',
  'dashboards.number-groupbookingenquiries': '団体予約に関するお問い合わせ',
  'dashboards.number-eventenquiries': 'イベントに関するお問い合わせ',
  'dashboards.number-longstayenquiries': '長期滞在のお問い合わせ',
  'dashboards.number-totaltickets': 'チケット',
  'dashboards.number-returncustomer': '返品のお客様',
  'dashboards.number-redirects': 'ウェブサイトのリダイレクト',
  'dashboards.number-bookingengineleads': '予約エンジンのリード',
  'dashboards.number-roomnightsreferred': '紹介された部屋泊数',
  'dashboards.number-revenuereferred': '参照される収益',
  'menu.bookingsmenu': '予約',
  'menu.guests': 'ゲスト情報',
  'menu.whatsnew': '新着情報',

  'menu.formbuilder': 'フォームビルダー',
  'forms.forms-title': 'フォーム',
  "dashboards.trainAI": "ドキュメントでAIをトレーニング",
  "dashboards.uploadDocuments": "AI があなたのビジネスを学び、あなたのように顧客をサポートできるようにドキュメントをアップロードしてください。 .doc、.pdf、.txt 形式のファイルを追加できます。",
  'dashboards.welcomeMessage': 'ウェルカムメッセージ',
  'dashboards.personalizeGreeting': '顧客への挨拶をカスタマイズして、あなたのブランド、スタイル、マナーを反映させ、最も温かい歓迎を提供しましょう。ブランドを反映した挨拶で温かい雰囲気を作りましょう。',
  'dashboards.addRoomDetails': '各部屋の詳細を追加して、ゲストが完璧な選択をするために必要なすべてを簡単に見つけられるようにし、予約手続きをよりシンプルかつ迅速にします。',
  'dashboards.trainAIFAQs': 'FAQ を使って AI をトレーニング',
  'dashboards.manualQuestions': 'いくつかの質問は文書で回答できなかったり、ウェブサイトで見つけられなかったりします。ここで、顧客が常に必要な情報をすぐに得られるように、手動で質問を追加できます。',
  'dashboards.publishAI': '最新の更新を反映するように AI を公開',
  'dashboards.retrainAfterChanges': 'ナレッジハブやフォームで変更を加えたときは、更新された情報でチャットボットを再訓練してください。AI を公開することで、チャットボットが最も正確で最新の回答を提供できるようになります。',
  'dashboards.enhanceKnowledge': '未回答の質問を追跡して AI の知識を強化',
  'dashboards.reviewUnanswered': 'AI が質問に答えられないか、限定的な詳細しか提供できないときは、これらの問い合わせがここに表示されます。ナレッジハブのギャップやゲストのユニークな質問を特定するために確認してください。',
  'dashboards.manageMedia': 'メディアを管理',
  'dashboards.mediaGallery': '部屋、アメニティ、ロゴ、またはあなたのデジタルアバターなどの画像をアップロードすると、これらはこのギャラリーに表示されます。視覚素材を管理する中心的な場所を提供し、お客様があなたのビジネスのユニークさを目にすることを保証します。',
  'dashboards.createForms': 'フォームを簡単に作成し、すべての送信時に通知を受け取ります。',
  'dashboards.manageForms': '顧客情報を収集し、通知を設定し、さまざまな言語向けにカスタマイズするためにフォームを作成および管理します。',
  'dashboards.personalizeResponse': '応答スタイルと会話の進行をパーソナライズ',
  'dashboards.controlConversation': 'この高度な機能により、異なるチャネルで顧客との会話がどのように展開されるかを形成および制御する能力が提供されます。',

  'menu.virtualfrontdesk': 'バーチャルフロントデスク',
  'menu.guestservice': 'お客様サービス',
  'virtual-front.common-questions': 'よくある質問',
  'virtual-front.add-on-upsells': 'アドオンとアップセル',
  'virtual-front.service-order': 'サービス注文',
  // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
  'virtual-front.guest-service-add-on-upsells': 'デジタル大要',
  'virtual-front.outbound': 'アウトバウンド',
  'virtual-messenger': 'メッセンジャーX',

  'missed-response.missed-response-title': '返信のタイトルがありませんでした',

  //unifed inbox
  'content.allconversation': 'すべての会話',
  'content.active': 'アクティブ',
  'content.tickets': 'チケット',
  'content.filter': 'フィルター',
  'content.createtickets': 'チケット作成',
  'content.conversation': '会話',
  'content.knowledgesearch': 'ナレッジ検索',
  'content.reply': '返信',
  'content.visitorinfo': '訪問者情報',
  'content.callinfo': '通話情報',
  'content.allinsights': 'すべてのインサイト',
  'content.availabilityrates': '利用状況と料金',
  'content.callback': '折り返し電話',
  'content.close': '閉じる',
  'content.sms': 'SMS',
  'content.timestamp': 'タイムスタンプ',
  'content.topics': 'トピック',
  'content.callingparty': '発信者',
  'content.accountdomain': 'アカウントドメイン',
  'content.calledparty': '着信者',
  'content.recording': '録音',
  'content.phonesystemoriginationcallid': '電話システム発信コールID',
  'content.phonesystemterminationcallid': '電話システム着信コールID',
  'content.uniqueconversationid': 'ユニーク会話ID',
  'content.regenerateinsights': 'インサイトを再生成',
  'content.customersentiment': '顧客の感情',
  'content.neutral': '中立',
  'content.customerreportedbroadbandoutage': '顧客は顧客IDとサービス開始日を提供し、ブロードバンドの障害を報告しました。',
  'content.conversationinsights': '会話のインサイト',
  'content.broadbandoutage': 'ブロードバンド障害',
  'content.customeridverification': '顧客ID確認',
  'content.serviceactivationdate': 'サービス開始日',
  'content.followups': 'フォローアップ',
  'content.actionneeded': '対応が必要',
  'content.uniqueConversationId': '一意の会話ID',
  'content.uniqueChatId': '一意のチャットID',
  'content.recording&transcript': '記録と文字起こし',
  'content.chatinsights': 'チャットインサイト',
  'content.visitedpages': '訪問ページ',
  'content.deviceinfo': 'デバイス情報',
  'content.chatstartedonthispage': 'このページでチャットが開始されました',
  'content.prechatinfo': 'チャット前情報',
  'content.notes': 'メモ',
  'content.reassign': '再割り当て',
  'content.open': '開く',
  "content.dismiss": "閉じる",
  "content.add_placeholder": "プレースホルダーの値を追加",
  "content.mobile_number": "携帯電話番号",
  "content.please_select": "選択してください",
  'content.sendwhatsapp': 'WhatsAppメッセージを送る',



  /* Missed Response */
  'feedback.missed-question': '見逃した質問',
  'feedback.conversation-summary': '会話の要約',
  'feedback.dates-in-spanish': '日付はスペイン語である必要があります',
  'feedback.resolve': '解決する',
  'feedback.ignore': '無視する',

  //integration
  // ja-JA
  'integration.select_properties': 'プロパティを選択',
  'integration.select_properties_enabled': 'この統合で有効になっているプロパティを選択',
  'integration.services_addons': 'サービスとアドオンを選択',
  'integration.services_visible': 'このページに表示されるサービスとアドオンを選択',
  'integration.appearance': '外観',
  'integration.appearance_customize': 'デジタルアシスタントの名前、アバター、カラーを設定',
  'integration.booking_calendar': '予約カレンダー',
  'integration.booking_calendar_style': '予約カレンダーのポップアップのスタイルを選択',
  'integration.nudges': 'ナッジ',
  'integration.nudges_setup': 'ウェブサイト訪問者を引きつけるプロアクティブメッセージを設定',
  'integration.position': '位置',
  'integration.position_control': 'ウェブサイト上のチャットウィジェットの位置を制御',
  'integration.custom_fonts': 'カスタムフォント',
  'integration.custom_fonts_upload': 'ページで使用するカスタムフォントをアップロード',
  'integration.custom_css': 'カスタムCSS',
  'integration.custom_css_usage': 'CSSを使用してデジタルコンペンディウムをカスタマイズ',
  'integration.location': '場所',
  'integration.location_embed': '埋め込み位置URLを追加',
  'integration.external_links': '外部リンク',
  'integration.external_links_add': 'リンクを追加',
  'integration.language': '言語',
  'integration.widget_languages': 'チャットウィジェットの言語を選択',
  'integration.chatbot_contact': 'チャットボット',
  'integration.chatbot_enable': 'デジタルアシスタントを有効にする',
  'integration.chatbot_security': 'メッセンジャーを安全に保つ',
  'integration.chatbot_trusted_pages': 'チャットボットを表示する信頼できるページをリスト',
  'integration.chatbot_publish': 'デジタルアシスタントを公開',
  'integration.chatbot_install': 'デジタルアシスタントをインストールするコードスニペットをコピー',

};
export default jaMessages;